import styled from '@emotion/styled'

import { breakpoints, colors, NativeLink, spacing, Text, typography } from 'main/ui'

export const ValuePropContainer = styled.div`
  border-top: 1px solid ${colors.border.default};
  display: flex;
  flex-direction: row;
  margin: ${spacing.minorScale(5)}px 0 ${spacing.minorScale(-5)}px 0;
  padding-top: ${spacing.majorScale(1)}px;
  position: relative;

  @media (min-width: ${breakpoints.lg}px) {
    border-top: none;
    padding-top: 0;
  }
`

export const Break = styled.div`
  border-top: 1px solid ${colors.border.default};
  left: 75px;
  position: absolute;
  right: 0;
  top: 16px;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${spacing.majorScale(1)}px 0;

  @media (min-width: ${breakpoints.lg}px) {
    margin: ${spacing.majorScale(4)}px 0 ${spacing.majorScale(1)}px;
  }
`

export const StyledText = styled(Text)`
  font-weight: ${typography.fontWeight.bold};

  @media (min-width: ${breakpoints.lg}px) {
    font-size: 20px;
    line-height: 30px;
  }
`

export const LinkContainer = styled.div`
  margin-top: ${spacing.majorScale(1)}px;
`

export const StyledLink = styled(NativeLink)<{ hasBorderRight?: boolean }>`
  font-weight: ${typography.fontWeight.light};
  border-right: ${props => (props.hasBorderRight ? `1px solid ${colors.border.default}` : '')};
  padding-right: ${props => (props.hasBorderRight ? `${spacing.majorScale(1)}px` : '0px')};
`

export const GraphicsContainer = styled.div`
  align-items: flex-end;
  align-self: flex-end;
  display: flex;
  flex-direction: row;
  margin: 0 ${spacing.majorScale(2)}px 0 ${spacing.majorScale(2)}px;
`

export const Graphic = styled.img`
  height: 100px;

  @media (min-width: ${breakpoints.md}px) {
    height: 120px;
  }

  @media (min-width: ${breakpoints.lg}px) {
    height: 140px;
  }
`
